// ─── 1. src/constants/roles.jsx ──────────────────────────────────────────────
// Add OFFICE_ADMIN to ROLES, ROLE_LABELS, ROLE_HIERARCHY:

export const ROLES = {
  SUPER_ADMIN:   'SUPER_ADMIN',
  OFFICE_ADMIN:  'OFFICE_ADMIN',
  ADMIN:         'ADMIN',
  ZONAL_MANAGER: 'ZONAL_MANAGER',
  AREA_MANAGER:  'AREA_MANAGER',
  EXECUTIVE:     'EXECUTIVE',
  SALES_OFFICER: 'SALES_OFFICER',
  FIELD_AGENT:   'FIELD_AGENT',
  GODOWN:        'GODOWN',
  ACCOUNTS:      'ACCOUNTS',   
};

export const ROLE_LABELS = {
  [ROLES.SUPER_ADMIN]:   'Super Admin',
  [ROLES.OFFICE_ADMIN]:  'Office Admin',   // ✅
  [ROLES.ADMIN]:         'Admin',
  [ROLES.ZONAL_MANAGER]: 'Zonal Manager',
  [ROLES.AREA_MANAGER]:  'Area Manager',
  [ROLES.EXECUTIVE]:     'Executive',
  [ROLES.SALES_OFFICER]: 'Sales Officer',
  [ROLES.FIELD_AGENT]:   'Field Agent',
  [ROLES.GODOWN]:        'Godown',
  [ROLES.ACCOUNTS]:      'Accounts',       // ✅
};

export const ROLE_HIERARCHY = {
  [ROLES.ACCOUNTS]:      10,
  [ROLES.GODOWN]:        10,
  [ROLES.FIELD_AGENT]:   20,
  [ROLES.SALES_OFFICER]: 30,
  [ROLES.EXECUTIVE]:     50,
  [ROLES.AREA_MANAGER]:  60,
  [ROLES.ZONAL_MANAGER]: 70,
  [ROLES.ADMIN]:         90,
  [ROLES.OFFICE_ADMIN]:  100, 
  [ROLES.SUPER_ADMIN]:   100,
};



